import GlnService from '../shared/service/GlnService'
import {
  HistoryScope,
  VestigingEnum,
} from 'shared/models/Enum'
import { IObjectResponse, IResponse } from 'shared/models/IResponse'
import { IKlant } from 'shared/models/IKlant'
import { IOrderType } from 'shared/models/IOrderType'
import { DeliveryLocationsOverviewModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationsOverviewModel'
import { DeliveryLocationModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationModel'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'
import {
  IPostKoppelRequest,
  IUpdateKoppelingRequest,
} from 'shared/models/PostRequestModel'

export class CustomerDeliveryLocationsService {
  public async deleteLocationLink(
    warehouse: VestigingEnum,
    customerNumber: number,
    linkId: number
  ): Promise<IResponse> {
    try {
      return await GlnService.postVerwijderKoppeling(
        warehouse.valueOf(),
        customerNumber,
        linkId
      )
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij verwijderen locatiekoppeling: ${e.Message}`,
      }
    }
  }

  public async saveLocationLink(
    link: DeliveryLocationModel,
    customer: CustomerModel
  ): Promise<IResponse> {
    try {
      let result = null
      console.log('service aanroep')
      console.log(link.deliveryagreementlocationid)
      if (link.deliveryagreementlocationid > 0) {
        const request: IUpdateKoppelingRequest = {
          eindDatum: link.enddate,
          ingangsDatum: link.startdate,
          klantNummer: customer.customerNumber,
          shipToLocationGlnId: link.shiptolocationid,
          routeToLocationGlnId: link.routetolocationglnid,
          routeToKlantId: link.routetocustomerid,
          koppelingId: link.deliveryagreementlocationid,
          combinatie: link.combination,
          koppelingType: link.deliveryagreementype === 'Dag' ? 2 : 1,
          orderTypes: link.ordertype === 'Alle' ? '' : link.ordertype,
          dagen: link.days === 'Alle' ? '' : link.days,
          toelichting: link.comment,
        }
        result = await GlnService.updateKoppeling(request)
      } else {
        const request: IPostKoppelRequest = {
          eindDatum: link.enddate,
          ingangsDatum: link.startdate,
          klantAfleverafspraakId: link.deliveryagreementid,
          klantAfleverafspraakRef: link.deliveryagreementreference,
          klantNummer: customer.customerNumber,
          shipToLocationGlnId: link.shiptolocationid,
          routeToLocationGlnId: link.routetolocationglnid,
          routeToKlantId: link.routetocustomerid,
          combinatie: link.combination,
          koppelingType: link.deliveryagreementype === 'Dag' ? 2 : 1,
          orderTypes: link.ordertype,
          dagen: link.days,
          toelichting: link.comment,
        }
        result = await GlnService.postKoppeling(request)
      }
      return result
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij opslaan locatiekoppeling: ${e.Message}`,
      }
    }
  }

  public async searchCustomers(
    customerNumber: number,
    agreementReference: string,
    locationName: string,
    warehouse: VestigingEnum,
    historyScope: HistoryScope
  ): Promise<IObjectResponse<DeliveryLocationsOverviewModel>> {
    try {
      return await GlnService.getCustomerLocationDeliveryAgreements(
        customerNumber,
        agreementReference,
        locationName,
        warehouse,
        historyScope
      )
    } catch (e) {
      return {
        success: false,
        errorMessage: `An error occured while searching for customer: ${e.Message}`,
        payLoad: null,
      }
    }
  }

  public async getCustomerById(
    customerId: number
  ): Promise<IObjectResponse<IKlant>> {
    try {
      return await GlnService.getKlantGegevensById(customerId)
    } catch (e) {
      return {
        success: false,
        errorMessage: `An error occured while searching for customer: ${e.Message}`,
        payLoad: null,
      }
    }
  }

  public async getPossibleOrderTypes(): Promise<IObjectResponse<IOrderType[]>> {
    try {
      return await GlnService.getPossibleOrderTypes()
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij ophalen ordertypes: ${e.Message}`,
        payLoad: null,
      }
    }
  }
}
